import "./ScoreCardLockButton.css";
import redLock from "./assets/red-lock.svg";
import blueLock from "./assets/blue-lock.svg";
import greenLock from "./assets/green-lock.svg";
import blackLock from "./assets/black-lock.svg";

interface ScoreCardLockButtonInfo {
  color: string;
  marked: boolean;
  size: string;
}

function ScoreCardLockButton({ color, marked, size }: ScoreCardLockButtonInfo) {
  let lockIconSrc: string;
  switch (color) {
    case "red":
      lockIconSrc = redLock;
      break;
    case "yellow":
      lockIconSrc = blackLock;
      break;
    case "blue":
      lockIconSrc = blueLock;
      break;
    case "green":
      lockIconSrc = greenLock;
      break;
    default:
      throw new Error(`unrecognized lock color ${color}`);
  }

  let mark = <span></span>;
  if (marked) {
    const classes = `marked ${color} ${size}`;
    mark = <div className={classes}>X</div>;
  }

  return (
    <div className={`lockButton centerContainer ${size}`}>
      <div className={`iconHolder ${size}`}>
        {mark}
        <img className={`lockIcon ${size}`} src={lockIconSrc}></img>
      </div>
    </div>
  );
}

export default ScoreCardLockButton;
